export const recurrenceTypes = [
  { value: 'DAILY', label: 'Hari' },
  { value: 'WEEKLY', label: 'Minggu' },
  { value: 'MONTHLY', label: 'Bulan' },
]

export const transitionMappings = {
  Aktif: {
    text: 'Nonaktifkan',
    icon: 'icon-outline_slash',
    transitionTo: 'inactive',
  },
  'Tidak Aktif': {
    text: 'Aktifkan',
    icon: 'icon-outline_checkmark',
    transitionTo: 'active',
  },
}

export const freqMappings = {
  1: 'MONTHLY',
  2: 'WEEKLY',
  3: 'DAILY',
}

export const dayItems = [
  {
    key: 'MO',
    label: 'Senin',
  },
  {
    key: 'TU',
    label: 'Selasa',
  },
  {
    key: 'WE',
    label: 'Rabu',
  },
  {
    key: 'TH',
    label: 'Kamis',
  },
  {
    key: 'FR',
    label: 'Jumat',
  },
  {
    key: 'SA',
    label: 'Sabtu',
  },
  {
    key: 'SU',
    label: 'Minggu',
  },
]

export const weekdayMappings = {
  0: 'MO',
  1: 'TU',
  2: 'WE',
  3: 'TH',
  4: 'FR',
  5: 'SA',
  6: 'SU',
}
